import { render } from "./horizontal-nav.vue?vue&type=template&id=5a4b5c56"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__